import * as React from 'react';

import {
  Text,
} from '@bluecurrent/web-component-lib';

export default function Item({
  hour,
  index,
}) {
  const isDividerNumber = (hour === '13' && index === 0)
    || hour === '00'
    || hour === '06'
    || hour === '12'
    || hour === '18';

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'columns',
        alignItems: 'flex-start',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          width: '80%',
          paddingTop: 10,
        }}
      >
        {
          isDividerNumber && (
            <Text
              fontSize="1em"
              textAlign="left"
              color="#88888D"
            >
              {hour}
            </Text>
          )
        }
      </div>
    </div>
  );
}
